import { Injectable } from '@angular/core';
import { ApplicationByFormFromApi, MyApplicationForUi } from '@core/typings/application.typing';
import { ProgramDetail } from '@core/typings/program.typing';
import { MyApplicationFormUI } from '@features/configure-forms/form.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
@Injectable({ providedIn: 'root' })
export class ApplicationApplicantState extends BaseYcState {
  readonly myApplications: MyApplicationForUi[];
  readonly revisionAlerts: MyApplicationFormUI[];
  readonly formsPastDue: MyApplicationFormUI[];
  readonly hasNominations: boolean;
  readonly currentApp: ApplicationByFormFromApi;
  readonly currentProgram: ProgramDetail;
}

